import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import MenuItem from '@rio-cloud/rio-uikit/MenuItem';
import type { IntlShape } from 'react-intl';

type TableDisplayOptionsDropdownProps = {
    compactRows: boolean;
    gridLines: boolean;
    intl: IntlShape;
    onToggleCompactRows: () => void;
    onToggleGridLines: () => void;
};

const TableDisplayOptionsDropdown = ({
    compactRows,
    gridLines,
    intl,
    onToggleCompactRows,
    onToggleGridLines,
}: TableDisplayOptionsDropdownProps) => {
    const hasActiveFilters = compactRows || gridLines;

    return (
        <ButtonDropdown
            aria-label={intl.formatMessage({
                id: 'intl-msg:common-message.table.filter.options',
                defaultMessage: 'Display options',
            })}
            title=''
            iconName={hasActiveFilters ? 'filter-active' : 'filter'}
            pullRight
            iconOnly
            noCaret
            dropdownClassName='width-250 padding-5'
            customDropdown={
                <>
                    <MenuItem
                        header
                        value={intl.formatMessage({
                            id: 'intl-msg:common-message.table.filter.options',
                            defaultMessage: 'Display options',
                        })}
                    />
                    <div className='padding-x-10 padding-bottom-15'>
                        <div className='text-bold text-color-darkest margin-bottom-10'>
                            {intl.formatMessage({
                                id: 'intl-msg:common-message.table.displayOptions.table',
                                defaultMessage: 'Table',
                            })}
                        </div>
                        <div className='space-y-5'>
                            <Checkbox
                                checked={gridLines}
                                label={intl.formatMessage({
                                    id: 'intl-msg:common-message.table.displayOptions.gridLines',
                                    defaultMessage: 'Grid lines',
                                })}
                                onChange={onToggleGridLines}
                            />
                            <Checkbox
                                checked={compactRows}
                                label={intl.formatMessage({
                                    id: 'intl-msg:common-message.table.displayOptions.condensed',
                                    defaultMessage: 'Compact rows',
                                })}
                                onChange={onToggleCompactRows}
                            />
                        </div>
                    </div>
                </>
            }
        />
    );
};

export default TableDisplayOptionsDropdown;
